<template>
  <div>
    <div>
      <button class="button is-success" @click="lauchCreate()">
        Ajouter un article PEF
      </button>
    </div>
    <table class="table">
      <thead>
        <tr>
          <th>Titre</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="pef in pefs" :key="pef.id">
          <td>{{ pef.title }}</td>
          <td>
            <button
              class="button is-warning update-button"
              @click="lauchUpdate(pef.id)"
            >
              <div class="icon">
                <img
                  src="@/assets/icons/pen-to-square-solid.svg"
                  alt="icone de crayon"
                />
              </div>
            </button>

            <button class="button is-danger" @click="lauchDelete(pef.id)">
              <div class="icon">
                <img
                  src="@/assets/icons/trash-can-solid.svg"
                  alt="icone de poubelle"
                />
              </div>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="modal" v-bind:class="{ 'is-active': isActiveModalUpdate }">
      <div class="modal-background" @click="close"></div>

      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title" v-if="actuTitle != null">
            {{ actuTitle }}
          </p>
          <p class="modal-card-title" v-if="actuTitle == null">
            Ajouter un article PEF
          </p>
          <button class="delete" aria-label="close" @click="close"></button>
        </header>
        <section class="modal-card-body">
          <div class="columns is-centered">
            <div class="column is-12-mobile is-12-tablet is-12-desktop">
              <form @submit.prevent="submitForm" class="box">
                <div class="field">
                  <label class="label">Titre</label>
                  <div class="control">
                    <input
                      class="input"
                      type="text"
                      placeholder="Titre"
                      v-model="title"
                    />
                  </div>
                </div>

                <div class="field">
                  <label class="label">Date</label>
                  <div class="control">
                    <input
                      class="input"
                      type="date"
                      placeholder="Titre"
                      v-model="date"
                    />
                  </div>
                </div>

                <div class="field no-game-part">
                  <label class="label">Sur plusieurs jours ?</label>
                  <div class="control">
                    <input type="checkbox" v-model="is_many_days" />
                  </div>
                </div>

                <div class="columns" v-if="is_many_days">
                  <div class="field column is-4">
                    <label class="label">Date début</label>
                    <div class="control">
                      <input
                        class="input"
                        type="date"
                        placeholder="Titre"
                        v-model="begin"
                      />
                    </div>
                  </div>
                  <div class="field column is-4">
                    <label class="label">Date Fin</label>
                    <div class="control">
                      <input
                        class="input"
                        type="date"
                        placeholder="Titre"
                        v-model="end"
                      />
                    </div>
                  </div>
                </div>

                <div class="field" v-if="!is_create">
                  <label class="label">Ancienne photo</label>
                  <td v-if="picture != null">
                    <figure class="image">
                      <img :src="baseURL + picture" alt="Ancienne photo" />
                    </figure>
                  </td>
                  <td v-if="picture == null">❌</td>
                </div>

                <div class="field">
                  <label class="label">Photo</label>
                  <div class="file has-name is-boxed">
                    <label class="file-label">
                      <input
                        class="file-input"
                        type="file"
                        @change="updateFile"
                        multiple
                      />
                      <span class="file-cta">
                        <span class="file-label">
                          Choisissez une ou plusieurs photos
                        </span>
                      </span>
                    </label>
                  </div>
                  <p class="help is-danger" v-if="!is_create">
                    En choisissant une nouvelle photo vous videz les photos
                    ajoutées lors de la création de cette actualité PEF
                  </p>
                </div>
                <div v-if="tempUrl.length > 0">
                  <div class="field" v-for="temp in tempUrl" :key="temp">
                    <div class="column">
                      <label class="label">Nouvelle photo</label>
                      <figure class="image">
                        <img :src="temp" alt="Nouvelle photo" />
                      </figure>
                      <button
                        class="delete"
                        @click="deleteFile(temp)"
                        v-if="is_create || (!is_create && filesReload)"
                      ></button>
                      <button
                        class="up"
                        v-if="
                          (getIndexFile(temp) > 0 && is_create) ||
                          (getIndexFile(temp) > 0 && !is_create && filesReload)
                        "
                        @click="upFile(temp)"
                      >
                        <img src="@/assets/icons/up-arrow.png" alt="up" />
                      </button>
                      <button
                        class="down"
                        v-if="
                          (getIndexFile(temp) < tempUrl.length - 1 &&
                            is_create) ||
                          (getIndexFile(temp) < tempUrl.length - 1 &&
                            !is_create &&
                            filesReload)
                        "
                        @click="downFile(temp)"
                      >
                        <img
                          src="@/assets/icons/arrow-down-sign-to-navigate.png"
                          alt="down"
                        />
                      </button>
                      <span class="place">
                        {{ getIndexFile(temp) + 1 }} / {{ tempUrl.length }}
                      </span>
                    </div>
                  </div>
                </div>

                <div class="field">
                  <label class="label">Description / Message</label>
                  <div class="control">
                    <textarea
                      class="textarea"
                      placeholder="Message"
                      name="desription"
                      v-model="description"
                    ></textarea>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
        <div class="notification is-danger is-light" v-if="is_failure">
          {{ error_messsage }}
        </div>
        <footer class="modal-card-foot">
          <button class="button is-success" v-if="is_create" @click="add()">
            Ajouter cette actualité PEF
          </button>
          <button
            class="button is-warning"
            v-if="!is_create"
            @click="update(id)"
          >
            Confirmer les modifications
          </button>

          <button class="button" @click="close">Annuler</button>
        </footer>
      </div>
    </div>
    <div class="modal" v-bind:class="{ 'is-active': isActiveModalDelete }">
      <div class="modal-background" @click="close"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title" v-if="pefActif.title != null">
            {{ pefActif.title }}
          </p>
          <button class="delete" aria-label="close" @click="close"></button>
        </header>
        <section class="modal-card-body">
          <h1>
            Êtes-vous certains de vouloir supprimer cette actualitée PEF ?
          </h1>
        </section>
        <footer class="modal-card-foot">
          <button class="button" @click="close">Annuler</button>
          <button
            class="button is-danger"
            v-if="pefActif.title != null"
            @click="deletepef(pefActif)"
          >
            Confirmer suppression
          </button>
        </footer>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  components: {},
  data() {
    return {
      baseURL: "https://api.saintcyrherbignacfootball.fr/",
      files: [],
      pefs: [],
      isActiveModalUpdate: false,
      isActiveModalDelete: false,
      pefActif: {},
      actuTitle: null,
      is_many_days: false,
      id: null,
      title: null,
      date: null,
      begin: null,
      end: null,
      type: null,
      description: null,
      picture: null,
      publication: null,
      is_create: false,
      tempUrl: [],
      role: null,
      is_failure: false,
      error_messsage: null,
      file: null,
      currentTags: [],
      picture_name: [],
      filesReload: false,
    };
  },
  methods: {
    //commun
    initializeData() {
      (this.actuTitle = null),
        (this.id = null),
        (this.title = null),
        (this.date = null),
        (this.begin = null),
        (this.end = null),
        (this.type = null),
        (this.description = null),
        (this.publication_date = null),
        (this.isActiveModalUpdate = false),
        (this.isActiveModalDelete = false),
        (this.typeId = null),
        (this.picture = null),
        (this.is_create = false),
        (this.tempUrl = []),
        (this.pefActif = {}),
        (this.files = []),
        (this.is_failure = false),
        (this.error_messsage = null),
        (this.picture_name = []),
        (this.filesReload = false),
        (this.is_create = false);
    },
    close() {
      this.initializeData();
    },
    updateFile(e) {
      if (!this.is_create && !this.filesReload) {
        this.files = [];
        this.tempUrl = [];
        this.filesReload = true;
      }
      Array.from(e.target.files).forEach((file) => {
        if (file.size > 5000000) {
          this.is_failure = true;
          this.error_messsage = "Image trop volumineuse";
          setTimeout(() => {
            this.is_failure = false;
            this.error_messsage = null;
          }, 3000);
          return;
        }
        this.files.push(file);
        this.tempUrl.push(URL.createObjectURL(file));
      });
    },
    upFile(e) {
      const index = this.tempUrl.findIndex((obj) => obj == e);
      var element = this.files[index];
      this.tempUrl.splice(index, 1);
      this.files.splice(index, 1);
      this.tempUrl.splice(index - 1, 0, e);
      this.files.splice(index - 1, 0, element);
    },
    downFile(e) {
      const index = this.tempUrl.findIndex((obj) => obj == e);
      var element = this.files[index];
      this.tempUrl.splice(index, 1);
      this.files.splice(index, 1);
      this.tempUrl.splice(index + 1, 0, e);
      this.files.splice(index + 1, 0, element);
    },
    getIndexFile(value) {
      return this.tempUrl.findIndex((obj) => obj == value);
    },
    deleteFile(value) {
      const index = this.tempUrl.findIndex((obj) => obj == value);
      this.tempUrl.splice(index, 1);
      this.files.splice(index, 1);
    },
    checkRequired() {
      if (this.is_many_days) {
        if (this.begin == null || this.end == null) {
          this.is_failure = true;
          this.error_messsage =
            "Veuillez selectionnez une date de fin et une date de debut";
          setTimeout(() => {
            this.is_failure = false;
            this.error_messsage = null;
          }, 3000);
          return false;
        }
      }
      if (this.title == null) {
        this.is_failure = true;
        this.error_messsage = "Veuillez renseignez un titre.";
        setTimeout(() => {
          this.is_failure = false;
          this.error_messsage = null;
        }, 3000);
        return false;
      }
      if (this.date == null) {
        this.is_failure = true;
        this.error_messsage = "Veuillez renseignez une date.";
        setTimeout(() => {
          this.is_failure = false;
          this.error_messsage = null;
        }, 3000);
        return false;
      }

      return true;
    },
    //partie ajout
    lauchCreate() {
      this.isActiveModalUpdate = true;
      this.is_create = true;
    },
    add() {
      if (!this.checkRequired()) {
        return;
      }
      const formDataPicture = new FormData();

      if (this.files.length > 0) {
        var data = 0;
        this.files.forEach((file) => {
          formDataPicture.append("picture", file);
          axios
            .create({
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            })
            .post("pef/upload", formDataPicture)
            .then((response) => {
              this.picture_name.push(response.data);
              data += 1;

              if (data == this.files.length) {
                const formData = {
                  title: this.title,
                  date: this.date,
                  begin: this.begin,
                  end: this.end,
                  description: this.description,
                  picture: this.picture_name,
                };

                axios
                  .create({
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: "Bearer " + localStorage.getItem("token"),
                    },
                  })
                  .post("pef", formData)
                  .then((response) => {
                    this.pefs.push(response.data);
                    this.initializeData();
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        });
      } else {
        const formData = {
          title: this.title,
          date: this.date,
          begin: this.begin,
          end: this.end,
          description: this.description,
          picture: this.picture_name,
        };

        axios
          .create({
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          })
          .post("pefs", formData)
          .then((response) => {
            this.pefs.push(response.data);
            this.initializeData();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    //partie modificatioon
    lauchUpdate(id) {
      var proxy = { ...this.pefs.find((x) => x.id == id) };
      const target_copy = Object.assign({}, proxy);
      (this.actuTitle = target_copy.title),
        (this.id = target_copy.id),
        (this.title = target_copy.title),
        (this.date = target_copy.date),
        (this.begin = target_copy.begin),
        (this.end = target_copy.end),
        (this.description = target_copy.description);

      Array.from(target_copy.pictures).forEach((file) => {
        this.tempUrl.push(this.baseURL + file.name);
      });

      this.isActiveModalUpdate = true;
      this.is_create = false;
    },
    update(id) {
      if (!this.checkRequired()) {
        return;
      }
      const formDataPicture = new FormData();
      if (this.files.length > 0) {
        var data = 0;
        this.files.forEach((file) => {
          formDataPicture.append("picture", file);
          axios
            .create({
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            })
            .post("pef/upload", formDataPicture)
            .then((response) => {
              this.picture_name.push(response.data);
              data += 1;
              if (data == this.files.length) {
                const formData = {
                  title: this.title,
                  date: this.date,
                  begin: this.begin,
                  end: this.end,
                  description: this.description,
                  picture: this.picture_name,
                };

                axios
                  .create({
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: "Bearer " + localStorage.getItem("token"),
                    },
                  })
                  .put("pef/" + id, formData)
                  .then((response) => {
                    const index = this.pefs.findIndex((obj) => obj.id == id);
                    this.pefs[index] = response.data;
                    this.initializeData();
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        });
      } else {
        const formData = {
          title: this.title,
          date: this.date,
          begin: this.begin,
          end: this.end,
          description: this.description,
          picture: this.picture_name,
        };

        axios
          .create({
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          })
          .put("pef/" + id, formData)
          .then((response) => {
            const index = this.pefs.findIndex((obj) => obj.id == id);
            this.pefs[index] = response.data;
            this.initializeData();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    //partie suppression
    lauchDelete(id) {
      var proxy = { ...this.pefs.find((x) => x.id == id) };
      const target_copy = Object.assign({}, proxy);
      this.pefActif = target_copy;
      this.isActiveModalDelete = true;
    },

    deletepef(pef) {
      axios
        .create({
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .delete("pef/" + pef.id)
        .then(() => {
          const index = this.pefs.indexOf(pef);
          this.pefs.splice(index, 1);
          this.initializeData();
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  beforeMount() {
    axios
      .create({
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .get("pef")
      .then((response) => {
        this.pefs = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
</script>
<style lang="scss">
.types {
  label {
    input {
      display: none;
    }
  }
  .isActive {
    border: 3px solid #e75913;
    border-radius: 30px;
  }
}

.tags {
  label {
    input {
      display: none;
    }
  }
  .isSelected {
    background-color: #e75913;
    color: #ffffff;
  }
}

.up,
.down,
.delete {
  border: none;
  border-radius: 50%;
  height: 20px;
  width: 20px;
  margin-top: 10px;
}

.up,
.down {
  margin-left: 10px;
}

.place {
  float: right;
  margin-top: 10px;
}

.update-button {
  margin-right: 15px;
  margin-bottom: 10px;
}
</style>
